import React, { useState } from 'react'
import { BtnV2, l } from '@manychat/manyui'

import { useKnowledgeEditorContext } from 'apps/aiAutomation/components/KnowledgeEditor/lib/context'
import { KnowledgeEntryDeleteModal } from 'apps/aiAutomation/components/KnowledgeEntryDeleteModal'
import {
  KnowledgeEntry,
  KnowledgeEntryState,
} from 'shared/api/requests/aiBusinessKnowledge/schemas'

interface EntryControlsProps {
  entry: KnowledgeEntry | null
  onSubmit: () => void
  isLoading: boolean

  onBackToReadMode?: () => void
  cancelText?: string
}

export const EntryControls = ({
  entry,
  onSubmit,
  onBackToReadMode,
  isLoading,
  cancelText,
}: EntryControlsProps) => {
  const isNewEntry = !entry
  const { source, onClose } = useKnowledgeEditorContext()

  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState<boolean>(false)

  const showDeleteButton = entry && entry.state !== KnowledgeEntryState.IN_PROCESS
  const showSaveButton = isNewEntry || entry.state === KnowledgeEntryState.PROCESSED

  const handleCancel = async () => {
    if (isNewEntry || !onBackToReadMode) {
      onClose()
      return
    }

    onBackToReadMode()
  }

  return (
    <div className="d-flex gap-sm">
      {isDeleteModalVisible && entry && (
        <KnowledgeEntryDeleteModal
          source={source}
          id={entry.id}
          onClose={() => setIsDeleteModalVisible(false)}
        />
      )}

      <BtnV2
        label={cancelText || l.translate('Cancel')}
        ariaLabel={cancelText || l.translate('Cancel')}
        onClick={handleCancel}
      />

      {showDeleteButton && (
        <BtnV2
          label={l.translate('Delete')}
          ariaLabel={l.translate('Delete')}
          variant="danger-light"
          data-test-id="ai-automation/knowledge-item-delete-button"
          onClick={() => setIsDeleteModalVisible(true)}
        />
      )}

      {showSaveButton && (
        <BtnV2
          label={isNewEntry ? l.translate('Add source') : l.translate('Save changes')}
          ariaLabel={isNewEntry ? l.translate('Add source') : l.translate('Save changes')}
          variant="primary"
          className="m-l-auto"
          onClick={onSubmit}
          loading={isLoading}
          data-test-id="ai-automation/knowledge-editor-save-button"
        />
      )}
    </div>
  )
}
